import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { firestore } from '../../../config/firebase';
import { createExpense } from '../../../store/actions/expenseActions';
import Spinner from '../../UIComponents/Spinner';
import lang from '../lang';

class AddExpense extends Component {
    state = {
        id: '',
        name: '',
        amount: 0,
        type: 'cash',
        uzsAmount: 0,
        usdAmount: 0,
        currency: 'UZS',
        createdAt: Date.now(),
        note: '',
        msg: {
            type: 'success',
            msg: '',
            status: false
        },
        readOnly: false,
        display: 'none'
    }

    inputHandler = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });

    }

    formSubmitHandler = (e) => {
        e.preventDefault();
        this.setState({ display: 'flex' });
        const { msg, id, readOnly, ...data } = this.state;
        let currencyBasedData = {};
        if (data.currency === 'UZS') {
            currencyBasedData = {
                uzsAmount: data.amount,
                usdAmount: parseFloat(data.amount / this.props.user.uzsAmount).toFixed(2)
            }
        } else {
            currencyBasedData = {
                uzsAmount: parseFloat(data.amount * this.props.user.uzsAmount).toFixed(2),
                usdAmount: data.amount
            }
        }
        firestore
            .collection('users')
            .doc(this.props.user.id)
            .collection('expenses')
            .add({ ...data, ...currencyBasedData }).then(doc => {
                this.props.createExpense({ id: doc.id, ...data, ...currencyBasedData });
                this.setState({
                    id: doc.id,
                    msg: {
                        type: 'success',
                        status: true,
                        msg: 'Expense has been created successfully',
                    },
                    readOnly: true,
                    display: 'none'
                });
            });
    }
    // Close alert messages
    alertMessageHandler = () => {
        this.setState({ msg: { status: false } });
    }

    render() {
        const {
            newItem: { title, name, namePlaceholder, amount, type, btn, note },
            payment: { cash, card, bank }
        } = lang[this.props.user.lang || 'en'];
        return (
            <div id="add-expenses">
                <Spinner display={this.state.display} />
                <div
                    className={`alert alert-${this.state.msg.type} mb-5`}
                    style={{ display: this.state.msg.status ? 'block' : 'none' }}
                >
                    <strong>{this.state.msg.msg}</strong> If you want to update go to <Link to={`/expenses/${this.state.id}/edit`}>Edit</Link> page.
                    <button type="button" className="close" onClick={() => this.alertMessageHandler()}>
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <h3 className="my-3 text-center">{title}</h3>
                <form onSubmit={(e) => this.formSubmitHandler(e)}>
                    <div className="form-group">
                        <label>{name}</label>
                        <input
                            type="text"
                            name="name"
                            className="form-control"
                            placeholder={namePlaceholder}
                            onChange={(e) => this.inputHandler(e)}
                            readOnly={this.state.readOnly}
                        />
                    </div>
                    <div className="form-row">
                        <div className="col-8">
                            <label>{amount}</label>
                            <div className="form-group d-flex expenses-amount">
                                <input
                                    type="number"
                                    name="amount"
                                    className="form-control"
                                    placeholder="1000"
                                    min="1"
                                    onChange={(e) => this.inputHandler(e)}
                                    readOnly={this.state.readOnly}
                                />
                                <select
                                    name="currency"
                                    className="form-control"
                                    onChange={(e) => this.inputHandler(e)}
                                >
                                    <option value="UZS">UZS</option>
                                    <option value="USD">$ - USD</option>
                                </select>
                            </div>
                        </div>
                        <div className="col-4">
                            <div className="form-group">
                                <label>{type}</label>
                                <select className="form-control" name="type" onChange={(e) => this.inputHandler(e)} disabled={this.state.readOnly}>
                                    <option value="cash">{cash}</option>
                                    <option value="card">{card}</option>
                                    <option value="bank">{bank}</option>
                                </select>
                            </div>
                        </div>
                    </div>

                    <div className="form-group">
                        <label>{note}</label>
                        <textarea
                            className="form-control"
                            name="note"
                            rows="3"
                            onChange={(e) => this.inputHandler(e)}
                            readOnly={this.state.readOnly}
                        />
                    </div>
                    <button className="btn btn-primary">{btn}</button>
                </form>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        user: state.user,
        currency: state.currency
    }
}

const mapDispatchToProps = dispatch => {
    return {
        createExpense: (data) => dispatch(createExpense(data))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AddExpense);